import { useCallback, useEffect, useState } from 'react';
import jwtDecode from 'jwt-decode';
import { TEMPORARY_TOKENS_KEY } from '../api/temporary';
import { clearStorageItem, setStorageItem } from '../helpers/helpers';
import { getJWTTokenRequest } from '../services/temporary';

interface IUser {
  organizationId: number;
  roles: string[];
  user_id: number;
}

interface IUseTemporaryAuth {
  token?: string;
}

export const useTemporaryAuth = ({ token }: IUseTemporaryAuth) => {
  const [user, setUser] = useState<IUser | null>(null);

  const decodeJWTToken = (token: string) => jwtDecode<IUser>(token);

  const getJWTToken = useCallback(async () => {
    if (token) {
      return await getJWTTokenRequest(token);
    }

    return null;
  }, [token]);

  const getUser = useCallback(async () => {
    try {
      const data = await getJWTToken();

      if (data) {
        setUser(decodeJWTToken(data.access));
        setStorageItem(TEMPORARY_TOKENS_KEY, data, 'session');
      }

      return data;
    } catch (error) {
      // TODO: handle error in case of incorrect token
    }
  }, [decodeJWTToken, getJWTToken]);

  useEffect(() => {
    return () => {
      clearStorageItem(TEMPORARY_TOKENS_KEY, 'session');
    };
  }, []);

  return { user, getUser };
};
